// Referral-app API client. Talks to vantage-api (which owns the referral
// domain — public sign-up + token-scoped portal reads). Migration 085.

const API_URL = process.env.REACT_APP_VANTAGE_API_URL || 'http://localhost:3001';

async function request(path, options = {}) {
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body?.error?.message || res.statusText || 'Request failed');
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return res.json();
}

// --- Public ---
export const applyReferrer = (body) =>
  request('/api/referrers/apply', { method: 'POST', body: JSON.stringify(body) });

// The token rides in the X-Referrer-Token header, never the URL: a query
// string lands in load-balancer access logs, and the token never expires.
export const validateToken = (token) =>
  request('/api/referrers/validate-token', { headers: { 'X-Referrer-Token': token } });

// --- Passwordless login (email code) ---
// request-login-code always returns 200 { ok: true } regardless of whether the
// email belongs to a referrer (anti-enumeration — never reveal existence).
export const requestLoginCode = (email) =>
  request('/api/referrers/request-login-code', { method: 'POST', body: JSON.stringify({ email }) });

// verify-login-code returns { token, portalUrl } on success; throws (status 400)
// with err.message from the standard error envelope on a bad/expired code.
export const verifyLoginCode = (email, code) =>
  request('/api/referrers/verify-login-code', { method: 'POST', body: JSON.stringify({ email, code }) });

// --- Portal (token-scoped via X-Referrer-Token) ---
const tokenHeaders = (token) => ({ 'X-Referrer-Token': token });

export const getMe = (token) => request('/api/referrers/me', { headers: tokenHeaders(token) });
export const getStats = (token) => request('/api/referrers/me/stats', { headers: tokenHeaders(token) });
export const getReferrals = (token) => request('/api/referrers/me/referrals', { headers: tokenHeaders(token) });
export const getLeaderboard = (token) => request('/api/referrers/leaderboard', { headers: tokenHeaders(token) });
